import React, { useEffect } from "react";
import { Input } from "antd";
import './index.less'
const isDev = process.env.NODE_ENV === 'development'
const baseurl = isDev?'/_api' :''
export default function IdentifyingCode(props) {

  const {isvalidatecode} = props
  const Code = () => {
    var num = Math.random();
    document.getElementById("img").src =
      // `${imgurl}${content}/_control/validateimage?` + num;
      `${baseurl}/_control/validateimage?tt=` + num;
  };
  useEffect(() => {
    if(isvalidatecode)
    Code()
  }, [isvalidatecode])
  return (
    <div style={{width:'100%'}}>
      <div style={{display:'flex'}}>
        <Input  className="validateinput" placeholder="请输入验证码" defaultValue={props.value} onChange={(e) => {
          props.onChange(e.target.value)
        }} />
        <img
          id="img"
          className="validateimg"
          onClick={() => {
            Code();
          }}
          style={{ marginLeft: "10px", height: "32px", cursor: "pointer" }}
        ></img>
      </div>
    </div>


  )
}